import type React from 'react';

interface LoadingPageProps {
  room?: string;
  message?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ room, message }) => {
  const resolvedMessage = message ?? 'Setting up your meeting…';
  const ariaLabel = room ? `${resolvedMessage} (${room})` : resolvedMessage;

  return (
    <output className="loadingPage" aria-live="polite" aria-label={ariaLabel}>
      <div className="loadingCard" aria-hidden="true">
        <div className="loadingIconWrapper">
          <div className="loadingSpinner" />
        </div>
        <div className="loadingMessage">{resolvedMessage}</div>
        <div className="loadingBar" role="progressbar" aria-busy="true" aria-label="Connecting">
          <span className="progress" />
        </div>
      </div>
    </output>
  );
};
